// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","rmDocument__title":"rmDocument__title-1j8wb","rmDocument__form":"rmDocument__form-2lQW6","rmDocument__footer":"rmDocument__footer-TLJ_F"};